import scrollLock from '../functions/_scrollLock.js' // スクロールロック
const spMenuTrigger = document.querySelectorAll('.js-gNav-open,.js-gNav-close,#gNav a,#overlay')
const spMenuTarget = document.querySelectorAll('.js-gNav-open,#gNav,#overlay')
for (let index = 0; index < spMenuTrigger.length; index++) {
  const element = spMenuTrigger[index]
  element.addEventListener(
    'click',
    function () {
      for (let index = 0; index < spMenuTarget.length; index++) {
        const element = spMenuTarget[index]
        element.classList.toggle('active')
      }
      scrollLock('body', '#overlay')

      if (spMenuTrigger[0].classList.contains('active')) {
        document.getElementById('spHeader').classList.add('active')
      }
    },
    false
  )
}
